/**
  HELOC lead-capture wizard API wrapper

**/

import { api } from "../common/utils"
import {
  HELOC_WORKFLOW_CONFIGS_ENDPOINT,
  HELOC_WORKFLOW_CONFIG_ENDPOINT
} from "../common/constants"
import {
  HelocWorkflowConfig,
  HelocWorkflowConfigUpsertPayload,
  HelocWorkflowConfigsListResponse
} from "../types"

const helocWorkflow = {
  find: async (brand_id: string): Promise<HelocWorkflowConfigsListResponse> => {
    const { data } = await api.get(
      `${HELOC_WORKFLOW_CONFIGS_ENDPOINT}?brand_id=${brand_id}`
    )
    return data
  },
  /**
   * With no id the endpoint resolves to the built-in wizard (`id: 0`) — the
   * starting point for a new config.
   */
  getDefaultDetails: async (): Promise<HelocWorkflowConfig> => {
    const { data } = await api.get(`${HELOC_WORKFLOW_CONFIG_ENDPOINT}?id=`)
    return data
  },
  updateOrCreate: async (
    payload: HelocWorkflowConfigUpsertPayload
  ): Promise<{ status: string; message?: string; id?: number }> => {
    const { data } = await api.post(HELOC_WORKFLOW_CONFIG_ENDPOINT, payload)
    return data
  },
  delete: async (
    id: string | number
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.delete(
      `${HELOC_WORKFLOW_CONFIG_ENDPOINT}?id=${id}`
    )
    return data
  }
}

export default helocWorkflow
